import React from "react";

import { Group } from "@visx/group";

import { ScatterPlotProps } from "./types";
import { DataPoint } from "../../types";

const ScatterPlot = ({
  top,
  left,
  data,
  getSidePoint,
  getBottomPoint,
  yMax = 0,
  bottomScale,
  colour = "#2DBFBE",
}: ScatterPlotProps) => {
  const getXPoint = (point: DataPoint) => {
    const x = getBottomPoint?.(point);

    return bottomScale.bandwidth ? x + bottomScale.bandwidth?.() / 2 : x;
  };

  const getYPoint = (point: DataPoint) => {
    const y = getSidePoint?.(point);

    const nodeHeight = yMax - y;

    return yMax - nodeHeight;
  };

  return (
    <Group
      top={top}
      left={left}
    >
      {data.map((dataPoint, index) => (
        <circle
          key={index}
          r={4}
          cx={getXPoint(dataPoint)}
          cy={getYPoint(dataPoint)}
          fill={colour}
        />
      ))}
    </Group>
  );
};

export default ScatterPlot;
